import * as yup from 'yup';

export const garages = yup.object().shape({
  active: yup.boolean(),
  ubication: yup
    .number()
    .typeError('Este campo es obligatorio')
    .when('active', {
      is: true,
      then: yup
        .number()
        .typeError('Este campo es obligatorio')
        .required('Este campo es obligatorio')
    }),
  cover: yup
    .number()
    .typeError('Este campo es obligatorio')
    .when('active', {
      is: true,
      then: yup
        .number()
        .typeError('Este campo es obligatorio')
        .required('Este campo es obligatorio')
    }),
  quantity: yup.number().when('active', {
    is: true,
    then: yup
      .number()
      .required('Este campo es obligatorio')
      .min(1, 'Debe ser mayor a 0')
  })
});
